<template>
  <div>
    <p
      class="text-justify"
    >Pon tus credenciales para acceder a los Sistemas Locales del Ministerio de Justicia y Transparencia Institucional</p>
    <v-form @submit.prevent="submit" ref="form" v-model="valid" lazy-validation>
      <v-text-field
        prepend-icon="person"
        name="usuario"
        label="Usuario"
        type="text"
        v-model="formLogin.username"
        :rules="usuarioRules"
        :disabled="loading"
        require
      ></v-text-field>
      <v-text-field
        id="contrasenia"
        prepend-icon="lock"
        name="constrasenia"
        label="Contraseña"
        v-model="formLogin.password"
        :rules="passwordRules"
        require
        :append-icon="eye? 'visibility' : 'visibility_off'"
        @click:append="() => (eye = !eye)"
        :type="eye ? 'password' : 'text'"
        :disabled="loading"
        autocomplete="password"
      ></v-text-field>
      <v-btn
        id="boton_login"
        color="#37696E"
        :loading="loading"
        :disabled="!valid"
        @click.native="loader='loading'"
        class="mt-4"
        type="submit"
        block
        rounded
      >
        Ingresar
        <span slot="loader">
          <v-progress-circular size="25" indeterminate color="white"></v-progress-circular>
        </span>
      </v-btn>
    </v-form>
  </div>
</template>
<script>
import Auth from "@/components/mixins/auth";
export default {
  data() {
    return {
      valid: true,
      formLogin: {
        username: "",
        password: ""
      },
      eye: true,
      usuarioRules: [v => !!v || "Usuario es requerido"],
      passwordRules: [v => !!v || "Contraseña es requerido"]
    };
  },
  mixins: [Auth],
  mounted(){
    this.$storage.set("tipo", 'local');
    this.$store.commit('setTipo','local');
  },
  computed:{
    loading() {
      return this.$store.state.loading;
    }
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.$Progress.start();
        this.iniciarSesion(this.formLogin);
      }
    }
  }
};
</script>